import { deeplinkDomainSuffix } from 'src/core/utils/AppConfig';

// The copy carries the production hosts; every other environment serves the same site on `<host><suffix>`.
export const environmentWebUrl = (url: string): string => {
	const suffix = deeplinkDomainSuffix();

	if (suffix.length === 0) {
		return url;
	}

	const value = new URL(url);

	if (value.hostname.endsWith(suffix)) {
		return url;
	}

	value.hostname = `${value.hostname}${suffix}`;

	return value.toString();
};
